import React from 'react'
import { Series } from '~/domain/Series'
import { Tooltip } from '~/components/Tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import styles from './index.module.scss'

interface NftHeaderProps {
  series: Series
}

export const NftHeader: React.FC<NftHeaderProps> = ({ series }) => {
  return (
    <div 
      data-testid="nft-header"
      className={ styles['nft-header'] }  
    >
      <img
        src={ series.organizer.avatarUrl }
        alt={ `Avatar of ${series.name}` }
        lang="en"
        className={ styles['nft-header__avatar'] }
      />
      <div className={ styles['nft-header__group'] } >
        <div className={ styles['nft-header__text'] } >
          { series.organizer.name }

          <FontAwesomeIcon
            className={ styles['nft-header__icon'] }
            icon={ faCircleCheck }
            data-tooltip-id="official"
            data-tooltip-content={ `This NFT is an official award by the ${series.organizer.name}` }
            data-tooltip-place="bottom"
          />

          <Tooltip id="official" />
        </div>

        <a 
          href={ `/series/${series.id}` }
          className={ styles['nft-header__link'] }
        >
          { series.name }
          <FontAwesomeIcon
            className={ styles['nft-header__icon'] }
            icon={ faArrowRight }
          />
        </a>
      </div>
    </div>
  )
}
